exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".NoteList .NoteCard {\n  margin-bottom: 40px; }\n  .NoteList .NoteCard:last-child {\n    margin-bottom: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/scenes/Notes/components/NoteList/NoteList.scss
// module id = 1551
// module chunks = 0